import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { StoreState } from '../../../../../reducers';
import { toggleSearchFieldVisibility } from '../../../../../containers/DriveItemList/Search/actions';
import { finishShare } from '../../../../../containers/Share/actions';
import { StyledCancelButton } from '../styles';
import { CancelActionOrigin } from '../../../../../containers/MenuManager/constants';
import { Translate } from 'react-redux-i18n';

interface CancelButtonProps {
	dispatch: Dispatch<StoreState>;
	actionOrigin: CancelActionOrigin;
	leavePage?: () => void;
}

const CancelButton = (props: CancelButtonProps) => {
	const handleClick = ({ actionOrigin, dispatch }) => {
		if (actionOrigin === CancelActionOrigin.Search) {
			dispatch(toggleSearchFieldVisibility());
		} else if (actionOrigin === CancelActionOrigin.Share) {
			dispatch(finishShare());
		} else if (props.leavePage && actionOrigin === CancelActionOrigin.Theater) {
			props.leavePage();
		}
	};

	const isInTheater = props.actionOrigin === CancelActionOrigin.Theater;
	return (
		<StyledCancelButton
			className={isInTheater ? 'TheaterCancelButton' : undefined}
			onClick={() => handleClick(props)}
			isInTheater={isInTheater}
		>
			<Translate value={isInTheater ? 'messages.close' : 'messages.cancel'} />
		</StyledCancelButton>
	);
};

export default connect()(CancelButton);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/MenuManager/Header/HeaderButton/CancelButton/index.tsx